// extracted by mini-css-extract-plugin
export var chevron = "_1k-d";
export var disabled = "_1k-b";
export var error = "_1k-c";
export var hideBorder = "_1k-1";
export var icon = "_1k-e";
export var input = "_1k-0";
export var large = "_1k-f";
export var open = "_1k-9";
export var placeholder = "_1k-a";
export var regular = "_1k-5";
export var singleRowInput = "_1k-2";
export var singleSelectInput = "_1k-3 _1k-0";
export var small = "_1k-4";
export var spinnerContainer = "_1k-i";
export var tag = "_1k-7";
export var tagsContainer = "_1k-8";
export var tagsInput = "_1k-6 _1k-0";
export var xSmall = "_1k-g";
export var xxSmall = "_1k-h";